import { Summary } from "../ads-procedure-report-page/procedure-models";

export const channels = ['w', 'd', 'm', 'c', 'nd'] as const;
export type ChannelType = typeof channels[number];

export const ChannelLabel:Record<ChannelType, string> = {
    w: "Whatsapp",
    d: "Direct",
    m: "Messenger",
    c: "Cadastro",
    nd: "Outro"
}

export type ChannelReport = {
    [key in ChannelType]?: Summary;
};

export type ChannelReportEntry = {
    id: number
    name: string
    info: ChannelReport
}

export type AccountChannelReport = {
    [key: string]: ChannelReport
}


export const ChannelIcon:Record<ChannelType, string> = {
    w: "fab fa-whatsapp",
    m: "fab fa-facebook-messenger",
    d: "far fa-paper-plane",
    c: "far fa-file-lines",
    nd: "fa fa-circle"
}

export const ChannelColor:Record<ChannelType, string> = {
    w: "color2",
    m: "color8",
    d: "color6",
    c: "color16",
    nd: "color1"
}
